export const getStyleTaskFilter = state => state.styleTask.filter
